<script setup>
import { useRouter } from "vue-router";
import { local, add } from "./helper/import";
import { getDefaultApi, exchangeApi } from "./helper/api";
import { reactive } from "vue";
import { computed } from "vue";
import { onMountedOrActivated } from "./helper/onMountedOrActivated";
import { Toast } from "@nutui/nutui";
import store from "@/store";

const userInfo = reactive({
  id: "",
  receiver: "",
  phone: "",
  district: "",
  detailAddress: "",
});
const exChange = computed(() => store.state.lottery.exChange);

async function pullDefault() {
  const res = await getDefaultApi();
  if (Number(res.code) === 0) {
    const { id, receiver, phone, district, detailAddress } = res.data;
    userInfo.id = id;
    userInfo.receiver = receiver;
    userInfo.phone = phone;
    userInfo.district = district;
    userInfo.detailAddress = detailAddress;
  } else {
    userInfo.id = undefined;
    userInfo.receiver = undefined;
    userInfo.phone = undefined;
    userInfo.district = undefined;
    userInfo.detailAddress = undefined;
  }
}
onMountedOrActivated(pullDefault);
window.pullDefaultAddress = pullDefault;
const isAddress = computed(() => userInfo.id);
const router = useRouter();
const toAddress = () => {
  window.easyearn.goAddressManagementPage();
};
const submit = async () => {
  // 兑换奖品啦
  const res = await exchangeApi({
    address_id: userInfo.id,
    draw_id: exChange.value.draw_id,
  });
  if (Number(res.code) === 0) {
    router.push({ name: "Success" });
  } else if(Number(res.code) === 80008){
    Toast.text('您已完成兑换，可在“我的兑换”中查看详情');
  } else {
    Toast.text(res.msg);
  }
};
</script>

<template>
  <div class="exchange">
    <div v-if="isAddress" class="address" @click="toAddress">
      <img class="local" :src="local" />
      <span class="name">{{ userInfo.receiver }}</span>
      <span class="phone">{{ userInfo.phone }}</span>
      <div class="addr">
        {{ userInfo.district }}{{ userInfo.detailAddress }}
      </div>
      <div class="arrow"></div>
    </div>
    <div v-else class="no_address" @click="toAddress">
      <img class="local" :src="local" />
      <span class="add_text">添加收货地址</span>
      <img class="add" :src="add" />
    </div>
    <div class="prize">
      <img :src="exChange.prize_img_url" class="img" />
      <div class="text">{{ exChange.prize_name }}</div>
      <div class="num">x{{ exChange.prize_number }}</div>
      <div class="btn" :class="isAddress ? '' : 'btn_opacity'" @click="submit">
        确认兑换
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.exchange {
  background-color: #f3f3f3;
  height: calc(100vh - 50px);
  overflow: hidden;

  .address {
    height: 88px;
    background: #ffffff;
    box-sizing: border-box;
    margin: 10px 0;
    padding: 15px 20px;
    position: relative;

    .local {
      width: 14px;
      transform: translateY(2px);
    }

    .name {
      font-size: 16px;
      color: #000000;
      margin-left: 10px;
    }

    .phone {
      font-size: 14px;
      color: #9a9a9a;
      margin-left: 10px;
    }

    .addr {
      margin-top: 10px;
      margin-left: 20px;
      font-size: 12px;
      color: #000000;
    }

    .arrow {
      width: 6px;
      height: 6px;
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      transform: rotate(-315deg);
      border: 1px solid;
      border-color: rgba(23, 24, 26, 0.7) rgba(23, 24, 26, 0.7) transparent
        transparent;
    }
  }

  .no_address {
    height: 60px;
    background: #ffffff;
    box-sizing: border-box;
    margin: 10px 0;
    padding: 15px 20px;
    position: relative;

    .local {
      width: 14px;
      transform: translateY(2px);
    }

    .add_text {
      font-size: 14px;
      color: #000000;
      margin-left: 10px;
      font-weight: 500;
      line-height: 30px;
    }

    .add {
      float: right;
      width: 22px;
      transform: translateY(4px);
    }
  }

  .prize {
    overflow: hidden;
    padding: 12px 20px;
    height: 100%;
    background-color: #ffffff;
    position: relative;

    .img {
      max-width: 88px;
      max-height: 88px;
      border-radius: 4px;
    }

    .text {
      font-size: 14px;
      color: #2a2b2e;
      position: absolute;
      left: 120px;
      top: 20px;
    }

    .num {
      font-size: 12px;
      color: #abaeb3;
      position: absolute;
      top: 70px;
      right: 20px;
    }

    .btn {
      width: 320px;
      height: 42px;
      background: #0088ff;
      border-radius: 21px;
      position: absolute;
      bottom: 150px;
      left: 50%;
      transform: translateX(-50%);
      color: #ffffff;
      text-align: center;
      line-height: 42px;
      font-weight: 700;
      font-size: 16px;
    }

    .btn_opacity {
      opacity: 0.4;
    }
  }
}
</style>
